import { render, staticRenderFns } from "./TokenCard.vue?vue&type=template&id=735ff17c&"
import script from "./TokenCard.vue?vue&type=script&lang=js&"
export * from "./TokenCard.vue?vue&type=script&lang=js&"
import style0 from "./TokenCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports